import { Injectable } from "@snap/ts-inject";
import { getCameraKitUserAgent } from "../platform/cameraKitUserAgent";
import type { CameraKitConfiguration } from "../configuration";
import { configurationToken } from "../configuration";
import type { FetchHandler } from "./defaultFetchHandler";
import { defaultFetchHandlerFactory } from "./defaultFetchHandler";
import { HandlerChainBuilder } from "./HandlerChainBuilder";
import { createHeadersModifyingFetchHandler } from "./headersModifyingFetchHandler";

/**
 * A Fetch implementation which adds headers required to make authenticated calls to the CameraKit backend service.
 *
 * @internal
 */
export const cameraKitServiceFetchHandlerFactory = Injectable(
    "cameraKitServiceFetchHandler",
    [configurationToken, defaultFetchHandlerFactory.token] as const,
    ({ apiToken }: CameraKitConfiguration, defaultFetchHandler: FetchHandler) => {
        return new HandlerChainBuilder(defaultFetchHandler).map(
            createHeadersModifyingFetchHandler((headers) => {
                headers.append("x-snap-client-user-agent", getCameraKitUserAgent());
                headers.append("authorization", `Bearer ${apiToken}`);
                return headers;
            })
        ).handler;
    }
);
